import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { closePopup } from '../../actions/uiActions'
import { editCustomer } from '../../actions/userActions'
import CloseIcon from '@mui/icons-material/Close';

class EditCustomer extends React.Component {
    state = {
        selectedCustomerId: -1,
        viewerLicenseId: "",
        builderLicenseId: ""
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.currentUser && this.props.currentUser.customerID) {
            this.setState({ selectedCustomerId: this.props.currentUser.customerID })
            this.setLicenseKeysBasedOnCustomerId(this.props.currentUser.customerID)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    handleClick = (event) => {
        event.preventDefault()
        this.props.closePopup()
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.props.editCustomer(this.state.selectedCustomerId,this.state.viewerLicenseId,this.state.builderLicenseId)
    }

    handleCustomerID = (event) => {
        event.preventDefault()
        this.setState({ selectedCustomerId: event.target.value, viewerLicenseId: "", builderLicenseId: "" })
        this.setLicenseKeysBasedOnCustomerId(event.target.value)
    }

    changeViewerLicenseId = (event) => {
        this.setState({ viewerLicenseId: event.target.value })
    }

    changeBuilderLicenseId = (event) => {
        this.setState({ builderLicenseId: event.target.value })
    }

    populateCustomers = () => {
        if (this.props.role === "IEAdmin") {
            return (
                <>
                    <h5 className="mainLable">Customer:</h5>
                    <div className="myInputOut">
                        <Select
                            className="myInput"
                            onChange={this.handleCustomerID}
                            value={this.state.selectedCustomerId}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                        >
                            <MenuItem value="" disabled hidden>
                                Select Customer
                            </MenuItem>
                            {this.props.customerList.map((x) => <MenuItem key={x.id} value={x.id}>{x.name}</MenuItem>)}
                        </Select>
                    </div>
                </>
            )
        }

        return null
    }

    setLicenseKeysBasedOnCustomerId(customerId) {
        for (let x = 0; x < this.props.customerList.length; x++) {
            let current = this.props.customerList[x]
            if (current["id"] === customerId) {
                if (current["viewerLicenseId"] && !this.isEmptyString(current["viewerLicenseId"])) {
                    this.setState({ viewerLicenseId: current["viewerLicenseId"] })
                } else {
                    this.setState({ viewerLicenseId: "" })
                }

                if (current["builderLicenseId"] && !this.isEmptyString(current["builderLicenseId"])) {
                    this.setState({ builderLicenseId: current["builderLicenseId"] })
                } else {
                    this.setState({ builderLicenseId: "" })
                }
            }
        }
    }

    isEmptyString = (str) => {
        return str.trim() === "";
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={this.handleClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <CloseIcon onClick={this.handleClick} className="closePoup" />
                <DialogTitle id="alert-dialog-title" className="changepassdialog">
                    Edit Existing Customer
                </DialogTitle>
                <DialogContent>
                    <form className="form" onSubmit={this.handleSubmit}>
                        {this.populateCustomers()}
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeViewerLicenseId}
                                value={this.state.viewerLicenseId}
                                placeholder="Viewer License ID"
                            />
                        </div>
                        <div className="myInputOut">
                            <input
                                type="text"
                                className="myInput"
                                onChange={this.changeBuilderLicenseId}
                                value={this.state.builderLicenseId}
                                placeholder="Builder License ID"
                            />
                        </div>
                        <button className="btn" type="submit" value="Submit" id="submit_btn">Submit</button>
                    </form>
                </DialogContent>
            </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {
        role: state.users.role,
        currentUser: state.users.currentUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, editCustomer }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditCustomer)